<template>
  <!-- tips容器 -->
  <div id="J-tips" class="ui-topic" style="z-index:9999"
  :style="{ left: css.left, top : css.top}"
  v-show="visible">
    <div class="inner_html tip-container">
        <img v-if="imgId" v-bind:src="src + imgId + '.jpg'">
    </div>
  </div>
  <!-- end -->
</template>

<style scoped>
    .ui-topic {
        background: rgba(0, 0, 0, 0.8);
        color: #fff;
        padding: 5px;
        position: absolute;
        top: 100px;
        left: 200px;
    }

    .ui-topic .inner_html {
        line-height: 20px;
        font-size: 12px;
        color: #fff;
        font-family: arial;
    }

    .ui-topic .inner_html a {
        color: #fff;
        font-weight: bold;
        text-decoration: none;
        border-bottom: 1px dotted #990000;
    }

    .ui-topic .inner_html a:hover {
        border-bottom: 2px solid #990000;
    }

    .ui-topic {
        color: #00ff00;
    }

    .ui-topic .itemDesc {
        width: 300px;
        margin-top: 10px;
        color: #a1e5ff;
    }

    .ui-topic .type2 {
        color: #fff;
    }

    .ui-topic .type3 {
        margin-bottom: 10px;
    }

    .ui-topic .green,
    .ui-topic .strength,
    .ui-topic .agility,
    .ui-topic .mentality,
    .ui-topic .iniMovementSpeed,
    .ui-topic .healthPoint,
    .ui-topic .manaPerSecond,
    .ui-topic .skillStats,
    .ui-integralAddition,
    .ui-topic .smPerSecond,
    .fightingCapAdd {
        color: #00ff00;
    }

    .ui-topic .skillAdd1 {
        margin-top: 10px;
    }

    .ui-topic .skillAdd1,
    .ui-topic .skillAdd2 {
        width: 260px;
    }

    .ui-topic .skillAdd1,
    .ui-topic .skillAdd2 {
        color: #0088ff;
    }

    .ui-topic .purple {
        color: #9205EA;
    }

    .ui-topic .gold,
    .ui-topic .type3 {
        color: #FFCC11;
    }

    .ui-topic .dGold {
        color: #dd9955;
    }

    .ui-topic .orange,
    .ui-topic .magicValue {
        color: #FF8800;
    }

    .ui-topic .blue {
        color: #0088ff;
    }

    .ui-topic .desc {
        max-width: 300px;
        word-break: break-all;
    }

</style>

<script>
export default {
    name : 'tips-pc',
    data (){
        return {
            css : {
                left : '',
                top : '',
                width : '100px',
            },
            visible : false,
            imgId : '',
            src : 'https://web-resource.17m3.com/m3guo/202111/a20211124back/images/tips/',
            pos_data : {
                x : 0,
                y : 0,
            },
        }
    },
    watch: {
        pos_data (newVal) {
            if (newVal) {
                this.setPosition(this.pos_data.x,this.pos_data.y);
            }
        }
    },    
    mounted (){       
        this.setPosition(this.pos_data.x,this.pos_data.y);
    },
    methods :{
      setPosition: function (x, y) {

        var topic = document.querySelector('#J-tips');

        var top = document.body.scrollTop || document.documentElement.scrollTop;
        var left = document.body.scrollLeft || document.documentElement.scrollLeft;

        x += left;
        y += top;

        var l = x + 20;
        var t = y - (topic.clientHeight * 0.5 + 100);
        var bRight = true;
        var bTop = true;
        var iPageRight = left + document.documentElement.clientWidth;
        var iPageTop = top + document.documentElement.clientHeight;

        if (l + topic.clientWidth > iPageRight) {
          bRight = false;

          l = x - (topic.clientWidth + 20);
        }

        if (t - topic.clientHeight < 0) {
          bTop = false;
          t = y - 10 - topic.clientHeight * 0.5;
        }


        this.css.left = l + 'px' // 减去外层div的left距离
        this.css.top = t + 'px'
      },        
    },
}
</script>


// WEBPACK FOOTER //
// src/components/ItemTipsPC/itemTipsPC.vue